import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, X } from 'lucide-react';
import { ImageUrlInput } from './ImageUrlInput';

export interface LogoLink {
  imageUrl: string;
  link?: string;
}

interface LogoLinksInputProps {
  value?: LogoLink[];
  onChange: (_links: LogoLink[]) => void;
}

export const LogoLinksInput: React.FC<LogoLinksInputProps> = ({
  value = [],
  onChange,
}) => {
  const [items, setItems] = useState<LogoLink[]>(value);

  useEffect(() => {
    setItems(value);
  }, [value]);

  const add = () => {
    const next = [...items, { imageUrl: '', link: '' }];
    setItems(next);
    onChange(next);
  };

  const remove = (index: number) => {
    const next = items.filter((_, i) => i !== index);
    setItems(next);
    onChange(next);
  };

  const update = (index: number, field: keyof LogoLink, val: string) => {
    const next = items.map((item, i) =>
      i === index ? { ...item, [field]: val } : item
    );
    setItems(next);
    onChange(next);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Itens</span>
        <Button type="button" variant="outline" size="sm" onClick={add} className="gap-2">
          <Plus className="w-4 h-4" />
          Adicionar logo
        </Button>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-4 text-sm text-gray-500 border-2 border-dashed border-gray-200 rounded-lg">
          Nenhum logo adicionado
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="flex gap-2 items-start">
              <div className="flex-1 grid grid-cols-2 gap-2">
                <ImageUrlInput
                  placeholder="URL da imagem do logo"
                  value={item.imageUrl}
                  onChange={(url) => update(index, 'imageUrl', url)}
                />
                <Input
                  placeholder="Link (opcional)"
                  value={item.link ?? ''}
                  onChange={(e) => update(index, 'link', e.target.value)}
                />
              </div>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => remove(index)}
                className="text-red-500 hover:text-red-700 hover:bg-red-50"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
